import { render } from "./Topup.vue?vue&type=template&id=64d90e79&scoped=true"
import script from "./Topup.vue?vue&type=script&lang=js"
export * from "./Topup.vue?vue&type=script&lang=js"

import "./Topup.vue?vue&type=style&index=0&id=64d90e79&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d90e79"]])

export default __exports__